import {isEmpty} from "../Utils";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {CopyToClipboard} from "react-copy-to-clipboard";
import {toggleModal} from "../../actions/modal.action";

const shareFb = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location.href);
const shareTw = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(window.location.href);

const ShareButton = () => {
    const translations = useSelector(
        (state) => state.langReducer.translationsReducer.translate
    );
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false)
    const settings = useSelector((state) => state.settingReducer.getSettingReducer.config);

    const handleCopy = () => {

        let	text = translations && !isEmpty(translations["copy_clipboard"])
            ? translations["copy_clipboard"]
            : "Copy in clipboard !"

        dispatch(toggleModal({opened: true, success: true, text: text}))
    };

    return (
        <div className={open ? "share-open": "share-closed"}>
            <button className="button button-blue shared" id="share_btn" onClick={() => setOpen(prevState => !prevState)}>
                {
                    translations && !isEmpty(translations["share_video"])
                        ? translations["share_video"]
                        : "share_video"
                }
                <svg id="arrow-menu"  width="4" height="7" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.05273 13.5577C1.346 13.5577 1.5791 13.4524 1.78213 13.2569L7.54961 7.6248C7.80527 7.36914 7.92559 7.10596 7.93311 6.78262C7.93311 6.45928 7.81279 6.18857 7.54961 5.94043L1.78213 0.300781C1.5791 0.105273 1.33848 0 1.05273 0C0.466211 0 0 0.466211 0 1.04521C0 1.33096 0.120313 1.60166 0.330859 1.81221L5.44414 6.78262L0.330859 11.7455C0.120313 11.9561 0 12.2268 0 12.5125C0 13.0915 0.466211 13.5577 1.05273 13.5577Z" fill="white"/>
                </svg>
            </button>
            <ul className="share-sub" style={{backgroundColor: settings?.accent_color}}>
                <li>
                    <a href={shareFb} target="_blank" rel="noopener noreferrer">Facebook</a>
                </li>
                <li>
                    <a href={shareTw} target="_blank" rel="noopener noreferrer">Twitter</a>
                </li>
                <li>
                    <CopyToClipboard onCopy={() => handleCopy()} text={window.location.href}>
                        <button className="copy-link">Copy Link</button>
                    </CopyToClipboard>
                </li>
            </ul>
        </div>
    )
}

export default ShareButton